// TODO : this is not typed properly, i.e. it doesn't properly check types

import {
  BillingInterval,
  copilotRoutes,
  editorRoutes,
  PLAN_SIGNUP_PARAM,
  REDIRECT_TO_AFTER_LOGIN_PARAM,
} from "@flowstepdesign/shared";

import { config } from "./config";

// against what `navigate` expects
export const ROUTES = {
  //home: "/",
  homeTop: "/#top",

  // TODO : move all routes to copilotRoutes?
  pricing: copilotRoutes.pricing,

  about: "/about",

  mcp: "/mcp",
  mcpClaudeCode: "/mcp/claude-code",
  mcpCursor: "/mcp/cursor",
  mcpClaude: "/mcp/claude",
  mcpWindsurf: "/mcp/windsurf",

  termsOfUse: copilotRoutes.termsOfUse,
  privacyPolicy: copilotRoutes.privacyPolicy,
  cookiePolicy: "/cookie-policy",
  affiliateProgramTerms: "/affiliate-program-terms",

  affiliates: "/affiliates",

  login: config.editorUrl + "/login",
  register: config.editorUrl + "/register",
  registerWithPlan: (planId: string, billingInterval: BillingInterval) => {
    const plan = `${PLAN_SIGNUP_PARAM}=${planId}:${billingInterval}`;
    return `${config.editorUrl}/register?${REDIRECT_TO_AFTER_LOGIN_PARAM}=${editorRoutes.home}?${encodeURIComponent(plan)}`;
  },
  registerAsAffiliate: `${config.editorUrl}/register?${REDIRECT_TO_AFTER_LOGIN_PARAM}=${editorRoutes.settingsReferrals}`,

  blog: "https://flowstep.ai/blog",

  docs: "https://docs.flowstep.ai/",
  changelog: "https://docs.flowstep.ai/changelog",
  bookACall: "https://calendly.com/matt-flowstep/flowstep-enterprise",
  pressKit:
    "https://drive.google.com/drive/folders/1xrbGZ0qm0yu9Ldj3CXF0YcZqMFdP5Ku9?usp=sharing",

  // TODO : pages will be made for these
  founders: "/#founders--TODO",
  useCases: "/#use-cases--TODO",
  designers: "/#designers--TODO",
  marketers: "/#marketers--TODO",
  sales: "/#sales--TODO",
};
